<template>

  <div class="portlet_wrapper">

    <div class="switch_label">
      <div v-for="label_name in labels" :key="label_name" @click="tapNavigation(label_name)"
        :class="{ active: label == label_name }">{{ label_name }}</div>
    </div>
    <select v-model="label" @change="tapNavigation(label)">
      <option v-for="label_name in labels" :key="label_name">{{ label_name }}</option>
    </select>

    <div class="cnt_block">
      <div v-if="isResidents() && obtainLimitGetter" class="obtain_limit">
        ＊最多只能從同一位{{ label == '職涯諮詢' ? '職涯諮詢師' : '業師' }}中獲得{{ obtainLimitGetter }}點點數
      </div>
      <div class="table_holder">
        <table>
          <thead>
            <tr>
              <th>日期</th>
              <th>時間</th>
              <th>活動名稱</th>
              <th>簽到時間</th>
              <th>獲得點數</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tr in obtainRecordGetter">
              <td v-if="tr.event_start_date == tr.event_end_date">{{ tr.event_start_date }}</td>
              <td v-else>{{ tr.event_start_date }}~{{ tr.event_end_date }}</td>
              <td>{{ tr.event_start_time }} {{ (tr.event_start_date) ? "~" : "" }}{{ tr.event_end_time }}</td>
              <td>{{ getEventName(tr) }}</td>
              <td>{{ tr.check_in_date }}</td>
              <td>{{ tr.record_amount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ObtainRecord',
  components: {
  },
  props: {
    currentStudent: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      label: '職涯諮詢',
      labels: ['職涯諮詢', '業師諮詢', '職涯講座', '工作坊', '徵才說明會', '實習說明會', '企業參訪','博覽會'],
      labels_display_type: ['residents', 'residents', 'lectures', 'lectures', 'lectures', 'lectures', 'corporate_visits','school_hire'],
      type: ['career_residents', 'workplace_residents', 'career_lectures_1', 'career_lectures_2', 'career_lectures_3', 'career_lectures_4', 'corporate_visits','school_hire'],
    }
  },
  computed: {
    ...mapGetters('pages/point', [
      'obtainRecordGetter',
      'obtainLimitGetter',
    ])
  },
  watch: {
    currentStudent() {
      this.updateViewTable();
    },
  },
  async created() {

    if (this.$route.query.qrcode) {
      await this.getStudentByToken()
      this.qrCodeValidation();
    }

    const specificSegment = this.$route.query.sub
    if (specificSegment) {
      this.updateActiveTab(specificSegment)
    }
    else {
      this.tapNavigation(this.label);
    }
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/point', [
      'getStudentPointByEventType',
    ]),

    ...mapActions('pages/point', [
      'createStudentPointByQRCode',
    ]),
    ...mapActions('pages/students', [
      'getStudentByToken',
    ]),
    async qrCodeValidation() {
      try {
        await this.createStudentPointByQRCode(this.$route.query.qrcode)
        this.$router.push({
          path: '/point',
        })

      } catch (err) {
        console.error(err)
      }
    },
    
    async pushTabQuery(sub) {
      await this.$router.push({
        path: '/point',
        query: {
          tab: '獲得紀錄',
          sub
        }
      });
    },
    updateActiveTab(sub) {
      this.label = sub;
    },
    async updateViewTable() {
      await this.getStudentPointByEventType({
        type: this.type[this.labels.indexOf(this.label)],
        student_id: this.currentStudent.student_pk_id,
      });
    },
    async tapNavigation(sub) {
      try {

        this.togglePageLoader(true);
        this.updateActiveTab(sub);
        await this.updateViewTable();
        await this.pushTabQuery(sub);
      }
      finally {
        this.togglePageLoader(false);
      }
    },

    getEventName(record) {
      let label_index = this.labels.indexOf(this.label);
      let display_type = this.labels_display_type[label_index];
      switch (display_type) {
        case 'residents': return `${record.event_name}`;
        case 'lectures': return `${record.event_name}`;
        case 'corporate_visits': return `${record.event_name}`;
        case 'school_hire': return `${record.event_name}`;
        default: return '-';
      }
    },

    isResidents() {
      let label_index = this.labels.indexOf(this.label);
      let display_type = this.labels_display_type[label_index];
      return display_type == 'residents';
    },
  }
}
</script>